import { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { RadioGroup, Modal, Button } from '@ets/design-system';

import { useDispatch, useSelector } from '_common/hooks';
import EditorManager from 'Editor/services/EditorManager';

import { closeModal } from '_common/modals/ModalsSlice';

import styles from './DeleteCellsModal.module.scss';
import { toast } from 'utils/toast';

const DeleteCellsModal = () => {
  const intl = useIntl();
  const dispatch = useDispatch();

  const isOpen = useSelector((state) => state.modals.open.DeleteCellsModal);

  const OPTIONS = [
    {
      label: (
        <>
          <FormattedMessage id="SHIFT_CELLS_LEFT" />
          <div className={styles.optionDescription}>
            {intl.formatMessage({
              id: 'SELECTED_CELLS_WILL_BE_DELETED_ADJECENT_WILL_SHIFT_LEFT',
            })}
          </div>
        </>
      ),
      id: 'scl',
    },
    {
      label: (
        <>
          <FormattedMessage id="SHIFT_CELLS_UP" />
          <div className={styles.optionDescription}>
            {intl.formatMessage({
              id: 'SELECTED_CELLS_WILL_BE_DELETED_CELLS_BELOW_WILL_SHIFT_UP',
            })}
          </div>
        </>
      ),
      id: 'scu',
    },
    {
      label: (
        <>
          <FormattedMessage id="DELETE_ENTIRE_ROW" />
          <div className={styles.optionDescription}>
            {intl.formatMessage({
              id: 'THE_ENTIRE_ROW_CONTAINING_SELECTED_CELLS_WILL_BE_DELETED',
            })}
          </div>
        </>
      ),
      id: 'der',
    },
    {
      label: (
        <>
          <FormattedMessage id="DELETE_ENTIRE_COLUMN" />
          <div className={styles.optionDescription}>
            {intl.formatMessage({
              id: 'THE_ENTIRE_COLUMN_CONTAINING_SELECTED_CELLS_WILL_BE_DELETED',
            })}
          </div>
        </>
      ),
      id: 'dec',
    },
  ];
  const [selected, setSelected] = useState(OPTIONS[0].id);

  const close = () => {
    dispatch(closeModal('DeleteCellsModal'));
    setSelected(OPTIONS[0].id);
  };

  const handleDeleteCells = () => {
    const manager = EditorManager.getInstance();
    switch (selected) {
      case 'scl':
        manager.deleteCells('SHIFT_LEFT');
        toast({
          variant: 'success',
          title: 'CELLS_REMOVED',
          message: 'CELLS_REMOVED_MESSAGE',
        });
        break;
      case 'scu':
        manager.deleteCells('SHIFT_UP');
        toast({
          variant: 'success',
          title: 'CELLS_REMOVED',
          message: 'CELLS_REMOVED_MESSAGE',
        });
        break;
      case 'der':
        manager.deleteRows();
        break;
      case 'dec':
        manager.deleteColumns();
        break;
      default:
        break;
    }
    close();
  };

  return (
    <Modal open={!!isOpen} close={close} width="60rem" testId="delete-cells">
      <Modal.Header>
        <FormattedMessage id="DELETE_CELLS" />
      </Modal.Header>
      <Modal.Body>
        <div className={styles.root}>
          <div className={styles.description}>
            <FormattedMessage id="DELETING_CELLS_AFFECTING_ADJACENT_SELECT_OPTION" />
          </div>
          <div className={styles.options}>
            <RadioGroup
              value={selected}
              onChange={(e) => setSelected(e.target.value)}
              items={OPTIONS.map(({ id, label }) => ({
                label,
                value: id,
              }))}
              direction="vertical"
              size="s"
              testId="delete-cells"
              className={styles.radioGroup}
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button size="m" variant="standard" onClick={close} testId="delete-cells-modal-cancel">
          <FormattedMessage id="global.cancel" />
        </Button>
        <Button
          size="m"
          variant="primary"
          style={{ margin: '0 0 0 1rem' }}
          onClick={handleDeleteCells}
          testId="delete-cells-modal-submit"
        >
          <FormattedMessage id="DONE" />
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteCellsModal;
